<template>
    <div class="part3 part">
        <div class="top">
					<div class="title">
						解决方案
					</div>
        </div>
        <p class="center">
						APP、PC、微信等多端联动，将“出现舆情、任务指派、过程跟踪、成果上报、数据分析、绩效考核”六大环节整合为一套解决方案，从而牢牢掌控网络舆论主导权。
        </p>
        <div class="bottom">
          <el-row class="line lineTop">
            <el-col class="lineBox" :span="8">
              <div class="box box1">
                <div class="textBox" :class="{animate: isAnimate}"> 
										<h3>出现舆情</h3>
										<p>通过各种渠道第一时间获取属地重要舆情</p>
                </div>
                <div class="imgBox" :class="{animate: isAnimate}">
                    <p><img src="../../static/images/icon1.png" alt=""></p>
                </div>
              </div>
            </el-col>
            <el-col class="lineBox" :span="8">
              <div class="box box2">
                <div class="textBox" :class="{animate: isAnimate}"> 
                    <h3>任务指派</h3>
                    <p>多场景下点对点布置任务细节，完成相应指派</p>
                </div>
                <div class="imgBox" :class="{animate: isAnimate}">
                    <p><img src="../../static/images/icon2.png" alt=""></p>
                </div>
              </div>
            </el-col>
            <el-col class="lineBox" :span="8">
              <div class="box box3">
                <div class="textBox" :class="{animate: isAnimate}">
                    <h3>过程跟踪</h3>
                    <p>管理者随时随地掌控人员情况和任务进度</p>
                </div>
                <div class="imgBox" :class="{animate: isAnimate}">
                    <p><img src="../../static/images/icon3.png" alt=""></p>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row class="line lineBottom">
             <el-col class="lineBox" :span="8">
              <div class="box box1">
                <div class="imgBox" :class="{animate: isAnimate}">
                    <p><img src="../../static/images/icon4.png" alt=""></p>
                </div>
                <div class="textBox" :class="{animate: isAnimate}">
                    <h3>成果上报</h3>
                    <p>网评人员完成任务后即时回传成果</p>
                </div>
              </div>
            </el-col>
            <el-col class="lineBox" :span="8">
              <div class="box box2">
                <div class="imgBox" :class="{animate: isAnimate}">
                    <p><img src="../../static/images/icon5.png" alt=""></p>
                </div>
                <div class="textBox" :class="{animate: isAnimate}">
                    <h3>数据分析</h3>
                    <p>基于不同维度，将人员任务数据做可视化呈现</p>
                </div>
              </div>
            </el-col>
            <el-col class="lineBox" :span="8">
              <div class="box box3">
                <div class="imgBox" :class="{animate: isAnimate}">
                    <p><img src="../../static/images/icon6.png" alt=""></p>
                </div>
                <div class="textBox" :class="{animate: isAnimate}">
                    <h3>绩效考核</h3>
                    <p>标准化管理机制和奖惩制度，提升任务协作效率</p>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
				<div class="linkBk">
          <div class="lineBg" :class="{animate: isAnimate}"></div>
        </div>
    </div>
</template>
<script>
export default {
    name :"Partthree",
    data(){
        return{
          isAnimate:false
        }
    },
    mounted:function(){
      document.addEventListener("scroll",this.actionAnima);
    },
    methods:{
      actionAnima:function(){
        let _self = this;
        const bodyH = document.body.scrollTop || document.documentElement.scrollTop;
        console.log(bodyH);
        if(bodyH <= 1200){
          _self.isAnimate = true;
        }
      }
    }
}
</script>
<style scoped>
	.part3{
    position: relative;
  }
  .part3 .top{
    height: 132px;
    line-height: 132px;
    width: 540px;
    margin: 100px auto 10px auto;
    background: url(../../static/images/solution.png) no-repeat;
    background-size: 100% auto;
    background-position: center top;
    text-align: center;
    font-size: 40px;
		animation: topBgDown 0.5s linear forwards;
		/* border: 1px solid green; */
  }
	.part3 .top .title{
		position: relative;
		opacity: 0;
		animation: topUp 0.6s linear forwards;
	}
  .part3 p.center{
		position: relative;
    width: 1000px;
    margin: 0 auto;
    text-align: center;
    font-size: 18px;
    color: #666;
    height: 50px;
		opacity: 0;
    /* border: 1px solid red; */
		animation: topUp 0.6s linear forwards;
		animation-delay:0.5s;
  }
  .part3 .bottom{
    width: 1200px;
    height: 480px;
    margin: 0 auto;
    margin-top: 60px;
  }
  .part3 .linkBk{
    position: absolute;
    top: 262px;
    left: 50%;
    z-index: -1;
    width: 1200px;
    height: 460px;
    margin-left: -600px;
  }
  .part3 .lineBg{
    height: 460px;
		opacity: 0;
    background: url(../../static/images/route.png) no-repeat;
    background-size: 100% 36%;
    background-position: center center;
		animation: bottomLineBg .5s linear forwards;
		animation-delay: 1.4s;
    /* border: 1px solid red; */
  }
  .part3 .bottom .line{
    height: 50%;
  }
  .part3 .bottom .lineBox{
    height: 100%;
  }
  .part3 .bottom .lineBox .box2{
    margin: 0 auto;
  }
  .part3 .bottom .lineBox .box3{
    float: right;
  }
  .part3 .bottom .lineBox .box{
    width:160px;
    height: 200px;
    text-align: center;
  }
  .part3 .bottom .lineTop .lineBox .box .textBox{
    height:82px;
		opacity: 0;
		position: relative;
  }
  .part3 .bottom .lineTop .lineBox .box .imgBox{
    height:112px;
    margin-top:-5px;
		position: relative;
		opacity: 0;
  }

	.part3 .bottom .lineTop .lineBox .box1 .textBox.animate{
		animation: bottomTextDown .5s linear forwards;
		animation-delay: .6s;
	}
	.part3 .bottom .lineTop .lineBox .box1 .imgBox.animate{
		animation: bottomImgUp .5s linear forwards;
		animation-delay: .8s;
	}
	.part3 .bottom .lineTop .lineBox .box2 .textBox.animate{
		animation: bottomTextDown .5s linear forwards;
		animation-delay: 1s;
	}
	.part3 .bottom .lineTop .lineBox .box2 .imgBox.animate{
		animation: bottomImgUp .5s linear forwards;
		animation-delay: 1.2s;
	}
	.part3 .bottom .lineTop .lineBox .box3 .textBox.animate{
		animation: bottomTextDown .5s linear forwards;
		animation-delay: 1.4s;
	}
	.part3 .bottom .lineTop .lineBox .box3 .imgBox.animate{
		animation: bottomImgUp .5s linear forwards;
		animation-delay: 1.6s;
	}

  .part3 .bottom .lineBottom .lineBox .box .textBox{
    height:82px;
		position: relative;
		opacity: 0;
  }
  .part3 .bottom .lineBottom .lineBox .box .imgBox{
    height:112px;
		position: relative;
		opacity: 0;
  }
	.part3 .bottom .lineBottom .lineBox .box1 .textBox.animate{
		animation: bottomTextUp .5s linear forwards;
		animation-delay: 1.8s;
	}
	.part3 .bottom .lineBottom .lineBox .box1 .imgBox.animate{
		animation: bottomImgDown .5s linear forwards;
		animation-delay: 2s;
	}
	.part3 .bottom .lineBottom .lineBox .box2 .textBox.animate{
		animation: bottomTextUp .5s linear forwards;
		animation-delay: 2.2s;
	}
	.part3 .bottom .lineBottom .lineBox .box2 .imgBox.animate{
		animation: bottomImgDown .5s linear forwards;
		animation-delay: 2.4s;
	}
	.part3 .bottom .lineBottom .lineBox .box3 .textBox.animate{
		animation: bottomTextUp .5s linear forwards;
		animation-delay: 2.6s;
	}
	.part3 .bottom .lineBottom .lineBox .box3 .imgBox.animate{
		animation: bottomImgDown .5s linear forwards;
		animation-delay: 2.8s;
	}

  .part3 .bottom .lineBox .box h3{
    font-weight: normal;
    margin:8px;
  }
  .part3 .bottom .lineBox .box p{
    color: #666;
    font-size: 14px;
    margin: 0;
  }
  .part3 .bottom .lineTop .lineBox .box img{
    margin-top: 25px;
  }
  .part3 .bottom .lineBottom .lineBox .box{
    margin-top: 30px;
  }
	/*------------动画---------------*/
  @keyframes topUp{
		from{
				top: 10px;
				opacity: 0;
		}to{
				top: 0px;
				opacity: 1;
		}
  }
	@keyframes topBgDown{
		from{
			background-position: center top;
		}to{
			background-position: center center;
		}
  }
	@keyframes bottomTextDown{
		from{
				top: -10px;
				opacity: 0;
		}to{
				top: 0px;
				opacity: 1;
		}
  }
	@keyframes bottomTextUp{
		from{
				top: 10px;
				opacity: 0;
		}to{
				top: 0px;
				opacity: 1;
		}
  }
	@keyframes bottomImgUp{
		from{
				top: 10px;
				opacity: 0;
		}to{
				top: 0px;
				opacity: 1;
		}
  }
	@keyframes bottomImgDown{
		from{
				top: -10px;
				opacity: 0;
		}to{
				top: 0px;
				opacity: 1;
		}
  }
	@keyframes bottomLineBg{
		from{
				opacity: 0;
		}to{
				opacity: 1;
		}
  }
  /*------------动画 end---------------*/
	@media (max-width: 1439px){
    .part3 p.center{
      width: 800px;
    }
    .part3 .bottom{
      width: 1000px;
    }
    .part3 .linkBk{
      width: 1000px;
      margin-left: -500px;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/Partthree.vue